var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterBlueIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.143c0 .473-.448.857-1 .857s-1-.384-1-.857V11h2v7.143zM9 18a1 1 0 1 1-2 0v-3h2v3zm-6 .1c0 .497-.448.9-1 .9s-1-.403-1-.9V13h2v5.1zM1 .9c0-.497.448-.9 1-.9s1 .403 1 .9V6H1V.9zM3 12H1c-.552 0-1-.373-1-.833V7.833C0 7.373.448 7 1 7h2c.552 0 1 .373 1 .833v3.334c0 .46-.448.833-1 .833zM7 .857C7 .384 7.448 0 8 0s1 .384 1 .857V8H7V.857zM9 14H7c-.552 0-1-.373-1-.833V9.833C6 9.373 6.448 9 7 9h2c.552 0 1 .373 1 .833v3.334c0 .46-.448.833-1 .833zm5-13a1 1 0 1 1 2 0v3h-2V1zm2 9h-2c-.552 0-1-.373-1-.833V5.833c0-.46.448-.833 1-.833h2c.552 0 1 .373 1 .833v3.334c0 .46-.448.833-1 .833z",
    fill: "#3285C2",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterBlueIcon);
export default __webpack_public_path__ + "static/media/filter-blue-icon.8626a2f8.svg";
export { ForwardRef as ReactComponent };